/**
 * „Passt an mein Auto?"-Check auf Felgen-Produktseiten. Nachfolger und
 * Obermenge von zr-fitment-et.js: statt nur der ET vier Zeilen —
 * Lochkreis, Einpresstiefe, Nabenbohrung, Radlast.
 *
 * Fahrzeugdaten: sessionStorage("zr_fitment"), das Echo des Konfigurator-
 * Abrufs (fitment-configurator.js doLookup(), schemaVersion 2, Quelle ist
 * die lizenzierte wheel-size.com-API; TOS-Einordnung steht dort im
 * Kommentar). Ohne gewaehltes Fahrzeug zeigt der Kasten nur den Einstieg
 * „Fahrzeug waehlen"; mit Fahrzeug, dessen Lochkreis nicht zum Produkt
 * passt, eine klare Passt-nicht-Zeile statt gar nichts.
 *
 * Datenlage je Zeile ist bewusst unterschiedlich hart:
 *  - Lochkreis: Metafeld (auch Mehrfachwerte) gegen vorn/hinten → ✓/✗
 *  - ET: Werksspanne aus stockWheels gegen custom.einpresstiefe → ✓/Hinweis
 *    (Logik unveraendert aus zr-fitment-et.js uebernommen)
 *  - Nabenbohrung: custom.nabenbohrung existiert nur bei einem Teil des
 *    Katalogs (Schmidt ja, RID nein) und ist teils GERUNDET (93 statt
 *    93,1). Vorhanden → Vergleich mit 0,5-mm-Rundungsband, darueber mit
 *    Zentrierring-Empfehlung samt vorbefuelltem Finder-Link; fehlt →
 *    Hinweiszeile mit Fahrzeugwert und Finder-Link nur mit innen=.
 *  - Radlast: kein Metafeld; steht bei einem Teil der Produkte als
 *    „Radlast 850 kg" im Beschreibungstext (gleiche Erkennung wie
 *    docs/content/fahrzeug-kollektionen/fahrzeug-tags.mjs). Gefunden →
 *    Wert anzeigen; die zulaessige Achslast des Fahrzeugs liefert die
 *    Fitment-API nicht, deshalb verweist die Zeile immer auf den
 *    Radlast-Check im Traglast-Artikel statt selbst zu urteilen.
 */
(function () {
  'use strict';

  function esc(s) {
    var div = document.createElement('div');
    div.textContent = s == null ? '' : String(s);
    return div.innerHTML;
  }

  function normalizeBolt(s) {
    return String(s || '').replace(/,/g, '.').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function boltMatches(vehicleBolt, vehicleRearBolt, productBoltRaw) {
    if (!productBoltRaw) return null; // keine Angabe am Produkt
    var candidates = normalizeBolt(productBoltRaw).split(' ').filter(Boolean);
    var front = vehicleBolt ? candidates.indexOf(normalizeBolt(vehicleBolt)) !== -1 : false;
    var rear = vehicleRearBolt ? candidates.indexOf(normalizeBolt(vehicleRearBolt)) !== -1 : false;
    return front || rear;
  }

  /** ET nur, wenn der Text genau einen Zahlenwert beschreibt (wie bisher). */
  function parseSingleEt(raw) {
    if (!raw) return null;
    var s = String(raw).trim();
    if (s === '' || s.indexOf('/') !== -1) return null;
    var m = s.replace(',', '.').match(/-?\d+(\.\d+)?/);
    if (!m) return null;
    var n = parseFloat(m[0]);
    return Number.isFinite(n) ? n : null;
  }

  function parseMm(raw) {
    if (!raw) return null;
    var m = String(raw).replace(',', '.').match(/\d+(\.\d+)?/);
    if (!m) return null;
    var n = parseFloat(m[0]);
    return Number.isFinite(n) ? n : null;
  }

  function vehicleEtRange(stockWheels) {
    var values = [];
    (stockWheels || []).forEach(function (w) {
      [w.front, w.rear].forEach(function (side) {
        if (side && typeof side.rimOffset === 'number' && Number.isFinite(side.rimOffset)) {
          values.push(side.rimOffset);
        }
      });
    });
    if (!values.length) return null;
    return { min: Math.min.apply(null, values), max: Math.max.apply(null, values) };
  }

  /** Radlast aus dem sichtbaren Beschreibungstext, z. B. „Radlast 850 kg". */
  function radlastAusSeite() {
    var kandidaten = document.querySelectorAll('.product-info__block.rte, .disclosure__content.rte, .product-info .rte');
    for (var i = 0; i < kandidaten.length; i++) {
      var m = (kandidaten[i].textContent || '').match(/Radlast\s*:?\s*([\d.,]+)\s*kg/i);
      if (m) {
        var n = parseFloat(m[1].replace(/\./g, '').replace(',', '.'));
        if (Number.isFinite(n) && n >= 200 && n <= 3000) return n;
      }
    }
    return null;
  }

  function num(v) {
    return v.toLocaleString('de-DE', { maximumFractionDigits: 1 });
  }

  function mm(v) {
    return v.toLocaleString('de-DE', { maximumFractionDigits: 1 }) + ' mm';
  }

  function zeile(status, titel, text) {
    var symbol = status === 'ok' ? '✓' : status === 'nein' ? '✕' : 'i';
    return (
      '<li class="zr-fc__zeile zr-fc__zeile--' + status + '">' +
      '<span class="zr-fc__symbol" aria-hidden="true">' + symbol + '</span>' +
      '<span class="zr-fc__inhalt"><strong>' + titel + '</strong> ' + text + '</span></li>'
    );
  }

  function init() {
    var box = document.querySelector('[data-zr-fitment-check]');
    if (!box) return;
    var d = box.dataset;

    var data = null;
    try {
      var raw = sessionStorage.getItem('zr_fitment');
      if (raw) data = JSON.parse(raw);
    } catch (e) { /* privater Modus o. ae., dann nur der Einstieg */ }
    if (data && data.schemaVersion !== 2) data = null;

    // Ohne Fahrzeug: nur der Einstieg, dezent.
    if (!data || !data.vehicle) {
      box.innerHTML =
        '<p class="zr-fc__einstieg">Passt diese Felge an Ihr Auto? ' +
        '<a href="' + esc(d.konfiguratorHref || '/pages/felgen-konfigurator') + '">Fahrzeug wählen</a>, ' +
        'dann prüfen wir Lochkreis, Einpresstiefe und Nabenbohrung direkt hier.</p>';
      box.hidden = false;
      return;
    }

    var zeilen = [];
    var alleOk = true;
    var passtNicht = false;

    // 1) Lochkreis
    var lk = boltMatches(data.boltPattern, data.rearBoltPattern, d.productBoltPattern);
    if (lk === null) {
      alleOk = false;
      zeilen.push(zeile('info', 'Lochkreis:', 'am Produkt nicht hinterlegt. Ihr Fahrzeug braucht ' + esc(data.boltPattern || '–') + '; verbindlich ist das Teilegutachten der Felge.'));
    } else if (lk) {
      zeilen.push(zeile('ok', 'Lochkreis passt:', esc(d.productBoltPattern) + ' entspricht Ihrem Fahrzeug (' + esc(data.boltPattern || data.rearBoltPattern) + ').'));
    } else {
      alleOk = false; passtNicht = true;
      zeilen.push(zeile('nein', 'Lochkreis passt nicht:', 'diese Felge hat ' + esc(d.productBoltPattern) + ', Ihr Fahrzeug braucht ' + esc(data.boltPattern || '–') + '. Passende Felgen finden Sie über den <a href="' + esc(d.konfiguratorHref || '/pages/felgen-konfigurator') + '">Felgen-Konfigurator</a>.'));
    }

    // 2) Einpresstiefe (nur sinnvoll, wenn der Lochkreis passt)
    var range = vehicleEtRange(data.stockWheels);
    var productEt = parseSingleEt(d.productEt);
    if (lk === true && range && productEt != null) {
      var rangeLabel = range.min === range.max ? 'ET ' + num(range.min) : 'ET ' + num(range.min) + '–' + num(range.max);
      if (productEt >= range.min && productEt <= range.max) {
        zeilen.push(zeile('ok', 'Einpresstiefe im Werksrahmen:', 'ET ' + num(productEt) + ' liegt in der Werksspanne (' + esc(rangeLabel) + ').'));
      } else {
        alleOk = false;
        var referenceEt = productEt < range.min ? range.min : range.max;
        var perSide = Math.round(Math.abs(referenceEt - productEt) * 10) / 10;
        var richtung = referenceEt - productEt > 0 ? 'außen' : 'innen';
        zeilen.push(zeile('info', 'Einpresstiefe weicht ab:', 'ET ' + num(productEt) + ' statt ' + esc(rangeLabel) + ', das Rad sitzt ca. ' + num(perSide) + ' mm je Seite weiter ' + richtung + '. Bei Aufrüstungen üblich; ob die Kombination zulässig ist, entscheidet das Teilegutachten.'));
      }
    } else if (lk === true) {
      alleOk = false;
      zeilen.push(zeile('info', 'Einpresstiefe:', productEt == null ? 'am Produkt nicht eindeutig hinterlegt; maßgeblich ist das Teilegutachten.' : 'für Ihr Fahrzeug liegt keine Werksspanne vor; maßgeblich ist das Teilegutachten.'));
    }

    // 3) Nabenbohrung / Zentrierring
    var nabe = typeof data.centreBoreMm === 'number' && Number.isFinite(data.centreBoreMm) ? data.centreBoreMm : null;
    var bohrung = parseMm(d.productNabenbohrung);
    var finderBase = d.zentrierringHref || '/collections/zentrierringe-kaufen-verschiedene-groessen';
    if (lk === true && nabe && bohrung) {
      if (Math.abs(bohrung - nabe) < 0.05) {
        zeilen.push(zeile('ok', 'Nabenbohrung passt direkt:', mm(bohrung) + ' entspricht Ihrer Fahrzeugnabe, kein Zentrierring nötig.'));
      } else if (bohrung > nabe) {
        zeilen.push(zeile('ok', 'Nabenbohrung passt mit Zentrierring:', mm(bohrung) + ' auf Ihre Nabe mit ' + mm(nabe) + '. <a href="' + esc(finderBase) + '?aussen=' + encodeURIComponent(bohrung) + '&innen=' + encodeURIComponent(nabe) + '">Passenden Ring im Finder öffnen</a>.'));
      } else if (nabe - bohrung <= 0.5) {
        // Rundungsband: Schmidt hinterlegt z. B. „93" bei realen 93,1-mm-Naben.
        // Bei <= 0,5 mm Differenz nie hart urteilen, das waere eine Falschaussage.
        alleOk = false;
        zeilen.push(zeile('info', 'Nabenbohrung:', 'die Produktangabe (' + mm(bohrung) + ') liegt knapp unter Ihrer Fahrzeugnabe (' + mm(nabe) + '), das ist in der Regel eine gerundete Angabe. Die exakte Bohrung steht im Teilegutachten der Felge.'));
      } else {
        alleOk = false; passtNicht = true;
        zeilen.push(zeile('nein', 'Nabenbohrung zu klein:', mm(bohrung) + ' ist kleiner als Ihre Fahrzeugnabe (' + mm(nabe) + '), die Felge geht so nicht auf die Nabe.'));
      }
    } else if (lk === true && nabe) {
      alleOk = false;
      zeilen.push(zeile('info', 'Nabenbohrung:', 'Ihre Fahrzeugnabe misst ' + mm(nabe) + '; die Bohrung dieser Felge steht im Teilegutachten. Falls ein Ring nötig wird: <a href="' + esc(finderBase) + '?innen=' + encodeURIComponent(nabe) + '">Zentrierring-Finder</a>.'));
    } else if (lk === true && bohrung) {
      alleOk = false;
      zeilen.push(zeile('info', 'Nabenbohrung dieser Felge: ' + mm(bohrung) + '.', 'Für Ihr Fahrzeug liegt kein Werkswert zum Nabendurchmesser vor. Ob ein Zentrierring nötig ist, steht im Teilegutachten; das passende Set finden Sie im <a href="' + esc(finderBase) + '?aussen=' + encodeURIComponent(bohrung) + '">Zentrierring-Finder</a>.'));
    }

    // 4) Radlast
    if (lk === true) {
      var radlast = radlastAusSeite();
      var radlastHref = d.radlastHref || '/blogs/news/felgen-traglast-berechnen-der-ultimative-leitfaden';
      if (radlast) {
        zeilen.push(zeile('info', 'Radlast dieser Felge: ' + radlast.toLocaleString('de-DE') + ' kg.', 'Sie muss mindestens die halbe zulässige Achslast Ihres Fahrzeugs tragen. <a href="' + esc(radlastHref) + '">Im Radlast-Check nachrechnen</a>.'));
      } else {
        zeilen.push(zeile('info', 'Radlast:', 'steht im Teilegutachten der Felge und muss mindestens die halbe zulässige Achslast tragen. <a href="' + esc(radlastHref) + '">Im Radlast-Check nachrechnen</a>.'));
      }
    }

    var badge = passtNicht
      ? '<span class="zr-fc__badge zr-fc__badge--nein">passt nicht</span>'
      : alleOk
        ? '<span class="zr-fc__badge zr-fc__badge--ok">alle Prüfpunkte grün</span>'
        : '<span class="zr-fc__badge zr-fc__badge--check">bitte prüfen</span>';

    box.innerHTML =
      '<div class="zr-fc__kopf"><span class="zr-fc__eyebrow">Passt-Check für ' + esc(data.vehicle) + '</span>' + badge + '</div>' +
      '<ul class="zr-fc__liste">' + zeilen.join('') + '</ul>' +
      '<p class="zr-fc__note">Der Check nutzt die Werksdaten Ihrer Modellgeneration und die Angaben am Produkt; er dient der allgemeinen Orientierung. Verbindlich sind die ABE oder das Teilegutachten der Felge und Ihre Fahrzeugpapiere; im Zweifel entscheidet die Prüfstelle.' +
      (d.contactHref ? ' <a href="' + esc(d.contactHref) + '">Unsicher? Jetzt beraten lassen.</a>' : '') + '</p>';
    box.hidden = false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
